//import React, {useState} from 'react';
//import {Button} from 'react-bootstrap';
//import { Link, NavLink } from 'react-router-dom';
//import Auth from './Auth/Auth';

const Header = (props) => {
  //  function ShowBotton() {
  //    const [show, setShow] = useState(false);

  //    const handleShow = () => {
  //       setShow(true);
  //    };
  //    return (
  //     <div>
  //       <h1>Componente con botón</h1>
  //       <button onClick={handleMostrarComponente}>Mostrar Componente</button>
  //       {mostrarComponente && <ComponenteMostrado />}
  //     </div>
  //   );
  //  }

  return (
    <header>
      <div
        className="Header"
        // className='w-full p-5 text-center bg-image brightness-50'
        style={{
          backgroundImage:
            "url('https://i.postimg.cc/wvXtVM88/buildings-668616-1920.jpg')",
          height: 1000,
          backgroundSize: "cover",
        }}
      >
        <div className="mask" style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}>
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="text-white p-5 d-grid gap-2 d-md-block">
              <h1 className="mb-3">Welcome!!!</h1>

              <h4 className="mb-3">Lot Ninja</h4>
              {/* <Button id="Auth" variant="outline-light"><Link to={"./Login"}>Login </Link></Button> */}

              <a
                className="btn btn-outline-light btn-lg"
                href={"./Auth"}
                role="button"
                style={{ marginRight: 10 }}
              >
                Login
              </a>
              {/* <Link to={"/Auth"}><Button id="Auth" variant="outline-light">Login </Button></Link>
              <NavLink to={"/Auth"}><Button id="Auth" variant="outline-light">Login </Button></NavLink>
              <NavLink to={"/Map"} id="Map" variant="outline-light">Map </NavLink> */}
              <a
                className="btn btn-outline-light btn-lg"
                href={"./Places"}
                role="button"
              >
                Map
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
